import React from 'react';
import { Value } from '@udecode/plate-common';
import { getRootProps } from '@udecode/plate-styled-components';
import { useFocused, useSelected } from 'slate-react';
import { MentionElementProps } from '@udecode/plate';
import styled, { css } from 'styled-components';

export const MemoryElement = <V extends Value>(props: MentionElementProps<V>) => {
  const { attributes, children, nodeProps, element, renderLabel } = props;

  const rootProps = getRootProps(props);

  const selected = useSelected();
  const focused = useFocused();

  return (
    <StyledMemory
      {...attributes}
      data-slate-value={element.value}
      selected={selected}
      focused={focused}
      {...rootProps}
      {...nodeProps}
    >
      {`{{${renderLabel ? renderLabel(element) : element.value}}}`}
      {children}
    </StyledMemory>
  );
};

const SelectedElement = css`
  border-radius: 4px;
  border: 1px solid ${p => p.theme.colors.gray500};
  background-color: ${p => p.theme.colors.gray400};
`;

const NotSelectedElement = css`
  border-radius: 4px;
  border: 1px solid ${p => p.theme.colors.gray300};
  background-color: ${p => p.theme.colors.gray200};
`;

const StyledMemory = styled.span`
  ${p => (p.selected ? SelectedElement : NotSelectedElement)}
`;
